import { NormalizedSchema, schema } from "normalizr";
import { ReferralEntity, ReferralSource, InvitationList } from "./typings";

/**
 * Referral entity
 * @type {schema.Entity<ReferralEntity>}
 */
const invitation = new schema.Entity<ReferralEntity>(
  "invitation",
  {},
  {
    idAttribute: "invitationId",
    processStrategy: ({
      invitationId,
      invitationCode,
      farmName,
      farmId,
      targetUser: { firstName, lastName, organizationName, role, email },
      status
    }: ReferralSource) => ({
      id: invitationId,
      farmName,
      code: invitationCode,
      firstName,
      lastName,
      org: organizationName,
      farmID: farmId,
      role,
      email,
      status
    })
  }
);

/**
 * List of invitations
 * @type {Array}
 */
const invitationList = new schema.Array(invitation);

/**
 * Send and received invitations
 * @type {Object}
 */
const invitationSchema = new schema.Object<Array<ReferralEntity>>({
  metadata: new schema.Values({}),
  sent: invitationList,
  received: invitationList
});

export type NormalizedInvitation = NormalizedSchema<{ invitation: InvitationList }, ReferralEntity["id"]>;

export type NormalizedInvitationList = NormalizedSchema<
  { invitation: InvitationList },
  {
    sent: Array<ReferralEntity["id"]>;
    received: Array<ReferralEntity["id"]>;
    metadata: Record<string, unknown>;
  }
>;

export default {
  invitation,
  invitationList,
  invitationSchema
};
